import Vue from 'vue';
import Vuex from 'vuex';
import { vuexPageModule } from './modules/VueX/vuexpage-module';
Vue.use(Vuex);
var store = {
    state: {
        version: '1.0.0'
    },
    modules: {
        vuexPageModule: vuexPageModule
    }
};
export default new Vuex.Store(store);
